import AbstractModel, { Model } from './abstract-model';

@Model('ComCommune')
export default class ComCommune extends AbstractModel {
  public numInsee: string = null;
  public numCarteGeol50: string = null;
  public numDept: string = null;
  public numCommune: string = null;
  public nom: string = null;
  public longi: number = null;
  public lat: number = null;
}